import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ModuleQCMResponseSearchParams } from '../../module-qcm-response-search-params';
import { ModuleQCMResponse } from '../../module-qcm-response';
import { Helpers } from '@app/shared';
@Component({
	selector: 'hpf-module-qcm-response-list',
	templateUrl: './module-qcm-response-list.component.html',
	styleUrls: [],
})
export class ModuleQCMResponseListComponent implements OnInit, OnDestroy {
	/** The filters */
	searchParams = new ModuleQCMResponseSearchParams(
		this.route.snapshot.queryParams
	);
	/** The search params subscription */
	private paramsSubscription: RxJsSubscription;
	/** Used to open or close filter drawer */
	filtersDrawer = false;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {}
	/** Init */
	ngOnInit() {
		// Update query string when params change
		this.paramsSubscription = this.searchParams.subscribe(() => {
			this.location.replaceState(
				'/module-qcm-response',
				Helpers.toQueryString(this.searchParams.toObject())
			);
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.paramsSubscription.unsubscribe();
	}
	/** Called when the user select a row in the table */
	onSelect(item: ModuleQCMResponse) {
		this.router.navigateByUrl(`/module-qcm-response/${item.getId()}`);
	}
	/** Called when the user click on create */
	onCreate() {
		this.router.navigate(['/module-qcm-response/create']);
	}
}
